export default "__VITE_ASSET__DxVZQl$R__"